/* eslint-disable jsx-a11y/role-supports-aria-props */
import React from 'react';
import PropTypes from 'prop-types';
import { looks } from './Chip.variants';

import { ChipOutline } from './Chip.styled';

const Chip = ({ look, children, onClick, label, isSelected, error }) => (
  <ChipOutline
    onClick={onClick}
    look={looks[look]}
    role="radio"
    aria-checked={isSelected}
    aria-label={label}
    aria-invalid={error}
    error={error}
  >
    {children}
  </ChipOutline>
);

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  look: PropTypes.oneOf(Object.keys(looks)),
  onClick: PropTypes.func,
  label: PropTypes.string,
  isSelected: PropTypes.bool,
  error: PropTypes.bool,
};

Chip.defaultProps = {
  look: 'default',
  onClick: null,
  label: '',
  isSelected: false,
  error: false,
};

export default Chip;
